type PromoConsentMode = 'oneTerms' | 'newTerms' | 'default';

export interface PromoConsentArgs {
  oneTerms: boolean;
  newTerms: boolean;
  receivePromosMain: boolean | undefined;
  receivePromos: boolean;
  receiveSmsPromos: boolean;
  receivePromosViaPhoneCalls: boolean;
}

export interface IPromoConsentsProps {
  receivePromos: boolean;
  receiveSmsPromos: boolean;
  receivePromosViaPhoneCalls: boolean;
}

const PROMO_CONSENTS_CONFIG: Record<
  PromoConsentMode,
  (args: PromoConsentArgs) => IPromoConsentsProps
> = {
  oneTerms: () => ({
    receivePromos: true,
    receivePromosViaPhoneCalls: true,
    receiveSmsPromos: true,
  }),
  newTerms: ({ receivePromosMain }) => ({
    receivePromos: !!receivePromosMain,
    receivePromosViaPhoneCalls: !!receivePromosMain,
    receiveSmsPromos: !!receivePromosMain,
  }),
  default: ({
    receivePromos,
    receivePromosViaPhoneCalls,
    receiveSmsPromos,
  }) => ({
    receivePromos: !receivePromos,
    receivePromosViaPhoneCalls: !receivePromosViaPhoneCalls,
    receiveSmsPromos: !receiveSmsPromos,
  }),
};

const getActiveMode = (
  oneTerms: boolean,
  newTerms: boolean
): PromoConsentMode => {
  if (oneTerms) return 'oneTerms';
  if (newTerms) return 'newTerms';
  return 'default';
};

export const getPromoConsents = (
  args: PromoConsentArgs
): IPromoConsentsProps => {
  const { oneTerms, newTerms } = args;
  return PROMO_CONSENTS_CONFIG[getActiveMode(oneTerms, newTerms)](args);
};
